var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useAuth0 } from "@auth0/auth0-react";
import { useQuery } from "react-query";
import apiService from "../services/api";
// The API scans mailboxes every 5 minutes, so checking more often only repeats the same answer
export const LEAD_REPLIES_REFETCH_INTERVAL_MS = 5 * 60 * 1000;
export const LEAD_REPLIES_QUERY_KEY = "lead-replies";
export const LEAD_REPLY_COUNT_QUERY_KEY = "lead-reply-count";
/** How many caught lead-reply threads are waiting, for the Deal Follow-ups menu badge (staff only) */
export function useOpenLeadReplyCount({ enabled }) {
    const { getAccessTokenSilently } = useAuth0();
    const { data } = useQuery([LEAD_REPLY_COUNT_QUERY_KEY], () => __awaiter(this, void 0, void 0, function* () { return (yield apiService.getOpenLeadReplyCount(yield getAccessTokenSilently())).count; }), { enabled, refetchInterval: LEAD_REPLIES_REFETCH_INTERVAL_MS });
    return data !== null && data !== void 0 ? data : 0;
}
